import { useEffect, useState } from "react";
import styled from "styled-components";
import { useEtc } from "../context/EtcContext";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";

const FoodContent = () => {
  const { i18n, t } = useTranslation();
  const {
    state: { ersData },
    fetchErsData,
  } = useEtc();
  const slug = `etc-dinner-${i18n.language}`;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // const [foodData, setFoodData] = useState(null);

  useEffect(() => {
    setError(null);
    // Always use cached data if available
    if (ersData && ersData[slug]) {
      setLoading(false);
      return;
    }
    setLoading(true);
    fetchErsData(slug)
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Something went wrong");
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  const foodData = ersData[slug];
  if (loading)
    return (
      <FoodDiv className="text-center">
        <Spinner animation="border" role="status">
          <p className="visually-hidden">{t("loading")}</p>
        </Spinner>
      </FoodDiv>
    );
  if (error)
    return (
      <FoodDiv>
        <div>Error: {error}</div>
      </FoodDiv>
    );
  if (!ersData) return null;

  return (
    <FoodDiv>
      <div>
        <h3>-{t("menu.STARTERS")}-</h3>
        {foodData?.map(
          (el, ind) =>
            el?.category === t("menu.STARTERS") && (
              <div
                key={el.id || ind}
                // className={menuItemId === el.id ? "active-item" : undefined}
              >
                <span>
                  <span>{el?.name}</span>
                  <p>{el?.description}</p>
                </span>
                <span>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </span>
              </div>
            ),
        )}
        {/* <h3>
          -
          {i18n.language === "en"
            ? "CHARCUTERIE & CHEESE"
            : "CHARCUTERIES ET FROMAGES"}
          -
        </h3>
        {foodData?.map(
          (el, ind) =>
            el?.category === "CHARCUTERIE & CHEESE" && (
              <div
                key={el.id || ind}
                // className={menuItemId === el.id ? "active-item" : undefined}
              >
                <span>
                  <span>{i18n.language === "en" ? el?.name : el?.name_fr}</span>
                  <p>
                    {i18n.language === "en"
                      ? el?.description
                      : el?.description_fr}
                  </p>
                </span>
                <span>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </span>
              </div>
            )
        )} */}
        <h3>-{t("menu.RAW_BAR")}-</h3>
        {foodData?.map(
          (el, ind) =>
            el?.category === t("menu.RAW_BAR") && (
              <div
                key={el.id || ind}
                // className={menuItemId === el.id ? "active-item" : undefined}
              >
                <span>
                  <span>{el?.name}</span>
                  {el?.additional &&
                    el?.additional
                      .split(",")
                      .map((item, idx) => (
                        <p key={`additional-${el.id || ind}-${item}`}>{item}</p>
                      ))}
                  <p>{el?.description}</p>
                </span>
                <span>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                  {el?.additionalprice &&
                    el?.additionalprice
                      ?.split(",")
                      ?.map((item, idx) => (
                        <div key={`additionalprice-${el.id || ind}-${idx}`}>
                          {i18n.language === "en" ? `$${item}` : `${item}$`}
                        </div>
                      ))}
                </span>
              </div>
            ),
        )}
        <h3>-{t("menu.CAVIAR")}-</h3>
        {foodData?.map(
          (el, ind) =>
            el?.category === t("menu.CAVIAR") && (
              <div
                key={el.id || ind}
                // className={menuItemId === el.id ? "active-item" : undefined}
              >
                <span>
                  <span>{el?.name}</span>
                  <p>{el?.description}</p>
                </span>
                <span>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </span>
              </div>
            ),
        )}
        <h3>-{t("menu.MAINS")}-</h3>
        {/* <div>
          {i18n.language === "en"
            ? "All mains are served with seasonal garnishes."
            : "Tous les plats principaux sont servis avec des garnitures de saison."}
        </div> */}
        {foodData?.map(
          (el, ind) =>
            el?.category === t("menu.MAINS") && (
              <div
                key={el.id || ind}
                // className={menuItemId === el.id ? "active-item" : undefined}
              >
                <span>
                  <span>{el?.name}</span>
                  <p>{el?.description}</p>
                </span>
                <span>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </span>
              </div>
            ),
        )}
        <h3>-{t("menu.STEAKS")}-</h3>
        <div>{t("food.allGrilledMeatsServed")}</div>
        {foodData?.map(
          (el, ind) =>
            el?.category === t("menu.STEAKS") && (
              <div
                key={el.id || ind}
                // className={menuItemId === el.id ? "active-item" : undefined}
              >
                <span>
                  <span>{el?.name}</span>
                  {el?.additional && <p>{el?.additional}</p>}
                  <p>{el?.description}</p>
                </span>
                <div>
                  <div>
                    {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                  </div>
                  {el?.additionalprice && (
                    <div>
                      {i18n.language === "en"
                        ? `$${el?.additionalprice}`
                        : `${el?.additionalprice}$`}
                    </div>
                  )}
                </div>
              </div>
            ),
        )}
        <h3>-{t("menu.HIGH_STEAKS")}-</h3>
        <div>
          {i18n.language === "en"
            ? "Served with your choice of two sauces."
            : "Servi avec deux sauces au choix."}
        </div>
        {foodData?.map(
          (el, ind) =>
            el?.category === t("menu.HIGH_STEAKS") && (
              <div
                key={el.id || ind}
                // className={menuItemId === el.id ? "active-item" : undefined}
              >
                <span>
                  <span>{el?.name}</span>
                  {el?.additional && <p>{el?.additional}</p>}
                  <p>{el?.description}</p>
                </span>
                <div>
                  <div>
                    {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                  </div>
                  {el?.additionalprice && <div>{el?.additionalprice}</div>}
                </div>
              </div>
            ),
        )}
        <h3>-{t("menu.ENHANCE_YOUR_STEAK")}-</h3>
        {foodData?.map(
          (el, ind) =>
            el?.category === t("menu.ENHANCE_YOUR_STEAK") && (
              <div
                key={el.id || ind}
                // className={menuItemId === el.id ? "active-item" : undefined}
              >
                <span>
                  <span>{el?.name}</span>
                  <p>{el?.description}</p>
                </span>
                <span>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </span>
              </div>
            ),
        )}
        {/* <h3>-{i18n.language === "en" ? "EXTRAS" : "SUPPLÉMENTS"}-</h3>
        {foodData?.map(
          (el, ind) =>
            el?.category === "EXTRAS" && (
              <div
                key={el.id || ind}
                // className={menuItemId === el.id ? "active-item" : undefined}
              >
                <span>
                  <span>{i18n.language === "en" ? el?.name : el?.name_fr}</span>
                  <p>
                    {i18n.language === "en"
                      ? el?.description
                      : el?.description_fr}
                  </p>
                </span>
                <span>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </span>
              </div>
            )
        )} */}
        <h3>-{t("menu.SIDES")}-</h3>
        {foodData?.map(
          (el, ind) =>
            el?.category === t("menu.SIDES") && (
              <div
                key={el.id || ind}
                // className={menuItemId === el.id ? "active-item" : undefined}
              >
                <span>
                  <span>{el?.name}</span>
                  <p>{el?.description}</p>
                </span>
                <span>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </span>
              </div>
            ),
        )}
        <h3>-{t("menu.SAUCES")}-</h3>
        {foodData?.map(
          (el, ind) =>
            el?.category === t("menu.SAUCES") && (
              <div
                key={el.id || ind}
                // className={menuItemId === el.id ? "active-item" : undefined}
              >
                <span>
                  <span>{el?.name}</span>
                  <p>{el?.description}</p>
                </span>
                <span>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </span>
              </div>
            ),
        )}
        <h3>-{t("menu.DESSERTS")}-</h3>
        {foodData?.map(
          (el, ind) =>
            el?.category === t("menu.DESSERTS") && (
              <div
                key={el.id || ind}
                // className={menuItemId === el.id ? "active-item" : undefined}
              >
                <span>
                  <span>{el?.name}</span>
                  <p>{el?.description}</p>
                </span>
                <span>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </span>
              </div>
            ),
        )}
        <h3>-{t("menu.DESSERT_WINE")}-</h3>
        {foodData?.map(
          (el, ind) =>
            el?.category === t("menu.DESSERT_WINE") && (
              <div
                key={el.id || ind}
                // className={menuItemId === el.id ? "active-item" : undefined}
              >
                <span>
                  <span>{el?.name}</span>
                  <p>{el?.description}</p>
                  {el?.additional && <p>{el?.additional}</p>}
                </span>
                <div>
                  <div>
                    {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                  </div>
                  {el?.additionalprice && (
                    <div>
                      {i18n.language === "en"
                        ? `$${el?.additionalprice}`
                        : `${el?.additionalprice}$`}
                    </div>
                  )}
                </div>
              </div>
            ),
        )}
        <h3>-{t("menu.SPECIALTY_COFFEES")}-</h3>
        {foodData?.map(
          (el, ind) =>
            el?.category === t("menu.SPECIALTY_COFFEES") && (
              <div
                key={el.id || ind}
                // className={menuItemId === el.id ? "active-item" : undefined}
              >
                <span>
                  <span>{el?.name}</span>
                  <p>{el?.description}</p>
                </span>
                <span>
                  {i18n.language === "en" ? `$${el?.price}` : `${el?.price}$`}
                </span>
              </div>
            ),
        )}
        <div>
          <a
            href={`/pdf/2026-etc-Summer-Menu-${i18n.language}.pdf`}
            rel="noopener noreferrer"
            download
          >
            {i18n.language === "en"
              ? "Download the menu"
              : "Télécharger le menu"}
          </a>
          {/* <a
            href={`/pdf/valentines-day.pdf`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {i18n.language === "en" ? "Valentines" : "Saint-Valentin"}
          </a> */}
        </div>
      </div>
    </FoodDiv>
  );
};
const FoodDiv = styled.div`
  height: 100%;
  /* max-height: 580px; */
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px;
  & > div {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 35px;
    overflow-y: scroll;
    scroll-behavior: smooth;
    ::-webkit-scrollbar {
      width: 2px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
      border-radius: 20px;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.3);
      border-radius: 20px;
    }
    /* Handle on hover */
    /* ::-webkit-scrollbar-thumb:hover {
    background: var(--lightgrey);
  } */
    & > h3 {
      text-align: center;
      font-weight: 500;
      margin-top: 36px;
      margin-bottom: 24px;
      font-size: 36px;
    }
    & > div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      /* cursor: pointer; */
      padding: 16px 8px;
      margin-right: 8px;
      transition: 0.4s all;
      gap: 5px;
      & > span {
        /* max-width: 200px; */
        & > div {
          margin-top: 10px;
        }
        & > span {
          font-size: 16px;
          color: var(--white);
          text-transform: uppercase;
          & > div {
            display: none;
          }
        }
        & > p {
          margin-top: 10px;
          font-weight: lighter;
          font-size: 16px;
          text-transform: capitalize;
        }
      }
      & > div {
        & > div:last-child {
          margin-top: 10px;
        }
      }
    }
    & > a {
      margin-top: 36px;
      align-self: center;
      text-align: center;
      border: none;
      padding: 10px 25px;
      font-size: 18px;
      color: var(--white);
      border: 1px solid var(--white);
      background: none;
      outline: none;
      border-radius: 20px;
      transition: opacity 0.4s ease-in;
      &:hover {
        transition: all 0.3s ease-in;
        background: var(--white);
        color: var(--black);
      }
    }
    & > div:last-child {
      justify-content: center;
      flex-wrap: wrap;
      align-items: center;
      gap: 10px;
      margin-top: 36px;
      & > a {
        align-self: center;
        text-align: center;
        border: none;
        padding: 10px 25px;
        font-size: 18px;
        color: var(--white);
        border: 1px solid var(--white);
        background: none;
        outline: none;
        border-radius: 20px;
        transition: opacity 0.4s ease-in;
        &:hover {
          transition: all 0.3s ease-in;
          background: var(--white);
          color: var(--black);
        }
      }
    }
    /* & > a:first-child {
      align-self: flex-start;
    } */
    /* .active-item {
      background: var(--secondary);
      border-radius: 10px;
    } */
  }
  @media screen and (max-width: 991px) {
    /* start of phone and tablet styles */
    padding: 0;
    & > div {
      /* max-height: 220px; */
      & > h3 {
        font-size: 28px;
        margin-top: 40px;
        margin-bottom: 28px;
      }
      & > div {
        padding: 6px 0;
        margin: 0;
        & > span {
          & > span {
            font-size: 16px;
          }
          & > p {
            font-size: 14px;
          }
        }
      }
    }
  }
`;
export default FoodContent;
